import { Base } from "@/atoms-react/text/Text.react";
import { LayoutTitle } from "../../_layout/index.react";
import ListCompanies from "./ListCompanies";
import {
  BuildingOffice2Icon,
  PlusCircleIcon,
  MagnifyingGlassIcon
} from "@heroicons/react/20/solid";
import { Button } from "@/atoms-react/button/Button.react";
import { Themes } from "@/types/theme";
import InputLabel from "@/atoms-react/input/Input.react";
import { useCallback, useEffect, useState } from "react";
import { AddCompanyModal } from "../../company/components/AddCompanyModal";
import { useAdmin } from "@/features/admin/hooks/use-admin";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";
import { useAppDispatch } from "@/redux/hooks";
import { ADMIN_SOURCE_PAGE, setAdminSourcePage } from "@/redux/slices/adminSlice";

const Admin = () => {
  const { t } = useTranslation();
  const [addCompany, setAddCompany] = useState<boolean>(false);
  const [queryLeName, setQueryLeName] = useState<string | undefined>(undefined);
  const [queryLeNameDisplayed, setQueryLeNameDisplayed] = useState<string | undefined>(undefined);

  const handleChangesQuery = useCallback(
    debounce((name: string) => {
      setQueryLeName(name);
    }, 1200),
    []
  );

  const open = () => {
    setAddCompany(true);
  };
  const close = () => {
    setAddCompany(false);
  };
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);

  const { companiesAdminQuery } = useAdmin();
  const { isPending, data, isFetching, isPlaceholderData, refetch } = companiesAdminQuery(
    page,
    limit,
    queryLeName
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setAdminSourcePage(ADMIN_SOURCE_PAGE.OLKY_PASS_PRO));
  }, []);

  return (
    <div className="px-6">
      <AddCompanyModal closeCompanyModal={close} open={addCompany} />

      <LayoutTitle>OlkyPass Pro</LayoutTitle>
      <div className="mt-10 flex flex-col justify-between md:flex-row">
        <div className="flex flex-col justify-center">
          <div className="flex flex-row items-center">
            <BuildingOffice2Icon className="mr-2 h-5 w-5 dark:text-white" />
            <Base className="font-semibold text-lg"> {t("admin_page.title.subtitle")}</Base>
          </div>
        </div>
        <Button
          dataCy="button-create-company"
          size="md"
          className="w-max"
          theme={Themes.primary}
          onClick={() => {
            open();
          }}
          iconPosition="after"
          icon={<PlusCircleIcon />}
        >
          {t("admin_page.button.create")}
        </Button>
      </div>
      <div className="py-10">
        <Base className="mb-2"> {t("admin_page.input_label.search")}</Base>
        <div className="mb-5 flex flex-row">
          <InputLabel
            value={queryLeNameDisplayed}
            placeholder={t("admin_page.input_placeholder.search")}
            suffixIcon={
              <div className="h-full">
                <MagnifyingGlassIcon
                  onClick={async () => {
                    setPage(1);
                    await refetch();
                  }}
                  className="text-primary"
                />
              </div>
            }
            onChange={(value) => {
              setPage(1);
              handleChangesQuery(value);
              setQueryLeNameDisplayed(value);
            }}
          />
        </div>
        <ListCompanies
          isPlaceholderData={isPlaceholderData}
          limit={limit}
          page={page}
          handleLimit={(limit) => setLimit(limit)}
          handlePage={(page) => setPage(page)}
          isLoading={isPending || isFetching}
          listcompaniesResponse={data}
        />
      </div>
    </div>
  );
};
export default Admin;
